/* L&S: Countdown bis Versandschluss auf der Produktseite. Rechnet immer in deutscher Zeit (Europe/Berlin). */
if (!customElements.get('ls-delivery-countdown')) {
  customElements.define(
    'ls-delivery-countdown',
    class LsDeliveryCountdown extends HTMLElement {
      connectedCallback() {
        const [h, m] = (this.dataset.cutoff || '12:00').split(':').map((n) => parseInt(n, 10) || 0);
        this.cutoffMinutes = h * 60 + m;
        this.shipDays = (this.dataset.days || '1,2,3,4,5').split(',').map(Number);
        this.holidays = new Set((this.dataset.holidays || '').match(/\d{4}-\d{2}-\d{2}/g) || []);
        this.textEl = this.querySelector('[data-ls-countdown-text]');
        this.inventory = document.getElementById(this.dataset.inventoryId);
        this.weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

        this.render();
        this.timer = setInterval(() => this.render(), 20000);
        if (this.inventory) {
          this.observer = new MutationObserver(() => this.render());
          this.observer.observe(this.inventory, { childList: true, subtree: true, characterData: true });
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.observer) this.observer.disconnect();
      }

      // aktuelle Zeit in Deutschland als { y, mo, d, wd, minutes }
      berlinNow() {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Berlin',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
          weekday: 'short',
        }).formatToParts(new Date());
        const get = (type) => parts.find((p) => p.type === type).value;
        const wdMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        return {
          date: new Date(Date.UTC(+get('year'), +get('month') - 1, +get('day'))),
          wd: wdMap[get('weekday')],
          minutes: +get('hour') * 60 + +get('minute'),
        };
      }

      isShipDay(date) {
        const iso = date.toISOString().slice(0, 10);
        return this.shipDays.includes(date.getUTCDay()) && !this.holidays.has(iso);
      }

      inStock() {
        if (!this.inventory) return true;
        if (this.inventory.innerText.trim() === '') return false;
        return !this.inventory.querySelector('.ls-delivery__dot--out');
      }

      // Text mit fett gesetzter Zeit bzw. fett gesetztem Tag (sicher, ohne innerHTML)
      setText(template, placeholder, value) {
        const [before, after = ''] = template.split(placeholder);
        const strong = document.createElement('strong');
        strong.textContent = value;
        this.textEl.replaceChildren(document.createTextNode(before), strong, document.createTextNode(after));
      }

      render() {
        if (!this.inStock()) {
          this.hidden = true;
          return;
        }
        const now = this.berlinNow();
        let message;
        if (this.isShipDay(now.date) && now.minutes < this.cutoffMinutes) {
          const left = this.cutoffMinutes - now.minutes;
          const hours = Math.floor(left / 60);
          const mins = left % 60;
          const time = hours > 0 ? `${hours} Std. ${mins} Min.` : `${mins} Min.`;
          message = [this.dataset.textCountdown, '[zeit]', time];
        } else {
          const next = new Date(now.date);
          let offset = 0;
          do {
            next.setUTCDate(next.getUTCDate() + 1);
            offset += 1;
          } while (!this.isShipDay(next) && offset < 30);
          const day = offset === 1 ? this.dataset.textTomorrow : `am ${this.weekdays[next.getUTCDay()]}`;
          message = [this.dataset.textNext, '[tag]', day];
        }
        this.setText(...message);
        this.hidden = false;
      }
    }
  );
}
